// append urls here, DO NOT remove this line

import { CartProductEntity } from "@features/cart/domain";
import type {
  CatalogedProduct,
  LockedProductEntity,
} from "@features/catalog/domain";
import { TopicEntity } from "@features/learning-center/domain";
import type { PreOrderRequestProduct } from "@features/pre-order/domain";
import { ProductEntity } from "@features/products/domain";
import { RecommendedProductEntity } from "@features/recommendations/domain";
import { CategoryEntity } from "../../../categories/domain";

export const URLS = {
  careers: "https://taager.bamboohr.com/careers",
  helpCenter: "/help-center",
  home: "/",
  merchantHome: "/home",
  clearCache: "/clear-cache",
  designSystem: "/design-system",
  onboardingQuestionnaire: "/questionnaire/onboarding",
  auth: {
    login: "/auth/login",
    forgetPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:id/:token",
    oldResetPassword: "/reset-password/:id/:token",
    register: "/auth/signup",
    loginWithEmail: "/auth/login-with-email",
  },
  profile: "/profile",
  wallet: {
    list: "/wallet",
    resetPassword: "/reset-wallet-password/:id/:resetToken",
  },
  orders: "/orders",
  preOrderRequests: "/pre-order-requests",
  dynamicIncentives: "/incentive-program",
  contactUs: "/contact-us",
  termsConditions: "/terms-conditions",
  privacyPolicy: "/privacy-policy",
  aboutUs: "/about-us",
  pages: {
    learningCenter: {
      root: "/learning-center",
      learningLevel: (level: TopicEntity) => `/learning-center/${level.name}`,
      learningLevelRoute: "/learning-center/:id",
    },
    orders: "/orders",
    shippingInfo: "/info",
    complaintsAndSuggestions: "/complain-suggest",
  },
  incentiveProgram: "/incentive-program",
  loyaltyProgram: "/loyalty",
  referral: "/referral",
  analytics: "/insights",
  preOrder: "/pre-order",
  stores: "/stores",
  zidIntegration: "/zid-integration",
  youcanIntegration: "/youcan-integration",
  lightFunnelsIntegration: "/light-funnels-integration",
  sallaIntegration: "/salla-integration",
  dukan: {
    settings: "/stores/edit-store",
  },
  categories: {
    root: "/products/category",
    viewCategory: (category: CategoryEntity) =>
      // TODO: remove this once the legacyId is removed from the category
      `/products/category/${completedUrlsPages.includes(URLS.products.catalog) ? category.id : category.legacyId}`,
    viewCategoryRoute: "/products/category/:id",
  },
  products: {
    list: "/products",
    catalog: "/products/catalog",
    search: "/products/search",
    viewSearch: (q: string) => `/products/search?q=${q}`,
    viewProducts: "/products/category",
    openForTesting: "/products/open-for-testing",
    // TODO: replace this route to be /locked-on-you directly as this route points to merchant's locked products
    lockedOnYou: "/products/locked-on-you",
    offers: "/products/offers",
    newArrivals: "/products/new-arrivals",
    bestSeller: "/products/best-seller",
    lockedOnYouProducts: "/products/locked-on-you-list",
    productDetailsRoute: "/products/:id",
    viewProduct: (
      product: Pick<
        Partial<
          CatalogedProduct &
            LockedProductEntity &
            PreOrderRequestProduct &
            ProductEntity &
            RecommendedProductEntity &
            CartProductEntity
        >,
        "parentId" | "variantId" | "id"
      >,
    ) => `/products/${product.variantId || product.parentId || product.id}`,
    viewProductCreatives: (sku: string, productName: string) =>
      `/creatives?id=${sku}&name=${productName}`,
  },
  recommendations: "/recommendations",
  cart: "/cart",
  uxProgram: "https://uxprogram.taager.com",
  info: "/info",
  customProductCheckout: "/product-checkout",
  checkout: "/checkout",
  dynamicPricingInfo: "/info#dynamic-pricing",
  tamara: "https://tamara.co/ar-SA",
};

export const completedUrlsPages = [
  URLS.home,
  URLS.auth.login,
  URLS.auth.forgetPassword,
  URLS.auth.resetPassword,
  URLS.auth.register,
  URLS.termsConditions,
  URLS.profile,
  URLS.stores,
  URLS.zidIntegration,
  URLS.sallaIntegration,
  URLS.youcanIntegration,
  URLS.wallet.list,
  URLS.wallet.resetPassword,
  URLS.info,
  URLS.customProductCheckout,
  URLS.analytics,
  URLS.preOrderRequests,
  URLS.lightFunnelsIntegration,
  URLS.orders,
  URLS.aboutUs,
  URLS.products.lockedOnYou,
  URLS.products.catalog,
  URLS.checkout,
  URLS.recommendations,
  URLS.referral,
  URLS.cart,
  URLS.loyaltyProgram,
  URLS.pages.learningCenter.root,
  URLS.pages.learningCenter.learningLevelRoute,
  URLS.privacyPolicy,
  URLS.preOrder,
  URLS.products.search,
  URLS.products.offers,
  URLS.products.openForTesting,
  URLS.products.newArrivals,
  URLS.products.bestSeller,
  URLS.products.lockedOnYouProducts,
  URLS.categories.viewCategoryRoute,
];

const domainToExclude = "taager.com";

// Update this array to test out any route in the dev subdomain with soft navigation before SRE team maps the route
// to the React project.
export const routesInDevelopment = [URLS.merchantHome];

export const routesInLocalHostDevelopment = [URLS.products.productDetailsRoute];

if (window.location.hostname === "localhost") {
  routesInDevelopment.push(...routesInLocalHostDevelopment);
  completedUrlsPages.push(...routesInLocalHostDevelopment);
}

if (window.location.hostname !== domainToExclude) {
  completedUrlsPages.push(...routesInDevelopment);
}
